import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

import { registerServiceWorker } from "./serviceWorkerRegistration";

let refreshing = false;

// Arms an auto-apply: once a worker is waiting, the NEXT route change tells it
// to take over and reloads. Firing on navigation (not immediately) means the
// user has already left their current screen, so no in-progress edit is lost.
export function useServiceWorkerUpdate(): void {
  const location = useLocation();
  const waitingWorker = useRef<ServiceWorker | null>(null);
  const armed = useRef(false); // skip the very first render's location

  useEffect(() => {
    if (process.env.NODE_ENV !== "production") return;
    registerServiceWorker((worker) => {
      waitingWorker.current = worker;
    });
    const onControllerChange = () => {
      if (refreshing) return;
      refreshing = true;
      window.location.reload();
    };
    navigator.serviceWorker?.addEventListener("controllerchange", onControllerChange);
    return () =>
      navigator.serviceWorker?.removeEventListener("controllerchange", onControllerChange);
  }, []);

  useEffect(() => {
    if (process.env.NODE_ENV !== "production") return;
    if (!armed.current) {
      armed.current = true;
      return; // ignore the initial location
    }
    const worker = waitingWorker.current;
    if (worker) {
      waitingWorker.current = null;
      worker.postMessage({ type: "SKIP_WAITING" }); // → controllerchange → reload
    }
  }, [location.pathname]);
}
